import { useStaticQuery, graphql } from "gatsby"

const getUniqueSorted = (data) => {
  return [...new Set(
    data.filter(Boolean)
  )].sort()
}

const useCreativeCommunityPartner = () => {
  
  const data = useStaticQuery(graphql`
		query CreativeCommunityQuery {
      eventsHubEventPartnerProfiles: allStoryblokEntry(
        filter: {
          field_component: {eq: "eventsHubEventPartnerProfile"}
          field_partnerType_string: {eq: "Creative Community"}
        }
      ) {
        edges {
          node {
            content
          }
        }
      }

      creativeCommunityDesigns: allStoryblokEntry(
        filter: {field_component: {eq: "creativeCommunityDesign"}}
      ) {
        edges {
          node {
            content
          }
        }
      }
    }
  `);

  const profiles = data.eventsHubEventPartnerProfiles.edges.map(({node}) => JSON.parse(node.content))
  const partnerCountries = profiles.map((p) => p.partnerCountry)
  const partnerSpecialities = profiles.map((p) => p.partnerSpeciality).flat()

  const partners = profiles.map(({
    getInTouchButtonLink, getInTouchButtonText, instagramProfileLink, learnMoreText,
    partnerDescription, partnerHeroImages, partnerLocation, partnerLogo,
    partnerName, twitterProfileLink, websiteLink, caseStudyButtonLink, caseStudyButtonText,
    facebookProfileLink, pinterestProfileLink, partnerSpeciality, partnerCountry,
    createdAt, contentful_id, partnerProfileUrlSlug, partnerType, communityProfileLink
  }) => ({
    getInTouchButtonLink,
    getInTouchButtonText,
    instagramProfileLink,
    learnMoreText,
    partnerDescription: { partnerDescription },
    partnerHeroImages: partnerHeroImages?.map((i) => ({
      file: { url: i.filename },
      title: i.title
    })),
    partnerLocation: {
      lat: partnerLocation?.lat,
      lon: partnerLocation?.lng
    },
    partnerLogo: {
      file: { url: partnerLogo?.filename },
      title: partnerLogo?.title
    },
    partnerName,
    twitterProfileLink,
    websiteLink,
    caseStudyButtonLink,
    caseStudyButtonText,
    facebookProfileLink,
    pinterestProfileLink,
    partnerSpeciality,
    partnerCountry,
    createdAt,
    contentful_id,
    partnerProfileUrlSlug,
    partnerType,
    communityProfileLink: communityProfileLink?.map(({ content: l }) => ({
      productType: l.productType,
      designTitle: l.designTitle,
      // designType: null, // MISSING IN DATA
      designStyle: l.designStyle,
      designsFiles: l.designsFiles.map((f) => ({
          file: { url: f.filename }
      })),
      designerProfile: {
        partnerLogo: {
          file: { url: partnerLogo?.filename },
        },
        partnerCountry,
        partnerName
      }
    }))
  })).filter((p) => !!p.partnerHeroImages && p.partnerHeroImages.length > 0)

  const designStyles = data.creativeCommunityDesigns.edges
    .map(({node}) => JSON.parse(node.content))
    .map((d) => d.designStyle)
    .flat()

  return {
    eventPartnersCountry: { distinct: getUniqueSorted(partnerCountries) },
    eventPartnerSpeciality: { distinct: getUniqueSorted(partnerSpecialities) },
    designStyle: { distinct: getUniqueSorted(designStyles) },
    eventPartners: { nodes: partners }
  };
}

export default useCreativeCommunityPartner;
